import { z } from 'zod';
import { isoDateTime } from './common';

export const testimonialInputSchema = z.object({
  author: z.string().min(1),
  role: z.string(),
  quote: z.string().min(1).max(600),
  formationId: z.string().nullable().default(null),
  published: z.boolean().default(false),
  displayOrder: z.number().int().default(0),
});
export type TestimonialInput = z.infer<typeof testimonialInputSchema>;

export const testimonialSchema = testimonialInputSchema.extend({
  id: z.string(),
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
});
export type Testimonial = z.infer<typeof testimonialSchema>;
